"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var JourneySteps_1 = require("../../constants/JourneySteps");
var cache_1 = require("../../../common/graphql/cache");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var journeySummaryStyles_1 = require("./journeySummaryStyles");
var JourneySummary = function () {
    var _a;
    var styles = journeySummaryStyles_1.default();
    var userJourney = cache_1.activeJourneyType();
    var summaryDetails = JourneySteps_1.Journeys.find(function (x) { return x.journeyType === userJourney; });
    if (!summaryDetails) {
        return null;
    }
    return (<core_1.Box data-test={'checkout:journey_list:summary'}>
      <core_1.Typography variant="h5" className={styles.summaryTitle}>
        <Translation_1.default id={summaryDetails.title}/>
      </core_1.Typography>
      <core_1.Typography className={styles.summaryDescription}>
        <Translation_1.default id={(_a = summaryDetails) === null || _a === void 0 ? void 0 : _a.description}/>
      </core_1.Typography>
    </core_1.Box>);
};
exports.default = JourneySummary;
